<template>
  <div class="banner">
    <div class="img-box">
      <div
          v-for="(item, index) in banner"
          :key="index"
          class="img-item"
          :class="{ active: bannerIndex === index || bannerIndex2 === index }"
          :style="bannerStyle(index)"
      >
        <div @click="_handleToPage(item.url)">
          <img :src="item.image" :alt="index" class="img-inner" style="object-fit: fill">
        </div>
      </div>
    </div>
    <div class="arrows">
      <div class="left" @click="bannerLeft">&lt;</div>
      <div class="right" @click="bannerRight">&gt;</div>
    </div>
    <div class="dots">
			<span
          v-for="(item, index) in banner"
          :key="index"
          :class="{ active: index === bannerIndex }"
          @click="onClickDot(index)"
      ></span>
    </div>
  </div>
</template>
<script>
import http from "@/util/http"

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Banner",
  data() {
    return {
      banner: [],
      bannerIndex: 0,
      bannerIndex2: 0,
      t: null,
    };
  },
  mounted() {
    this.scrollBanner()
    this._getList()
  },
  methods: {
    _handleToPage(e) {
      console.log(e)
      // router.push({
      //   path: '/' + e,
      //   query: {
      //     date:new Date().getTime()
      //   }
      // })
    },
    scrollBanner() {
      this.t && clearInterval(this.t);
      this.t = setInterval(() => {
        this.bannerRight();
      }, 3000);
    },
    bannerStyle(index) {
      const {bannerIndex, banner} = this;
      const base = document.documentElement.clientWidth
      let w = 0;
      if (bannerIndex === index) {
        w = 0;
      }
      // 最后一个index，且bannerIndex=0时
      else if (bannerIndex === banner - 1 && index === 0) {
        w = base;
      }
      // 第一个index，且bannerIndex=最后一个时
      else if (bannerIndex === 0 && index === banner - 1) {
        w = -base;
      } else {
        w = base * (index - bannerIndex);
      }
      return `transform: translateX(${w}px);`;
    },
    bannerLeft() {
      this.bannerIndex2 = this.bannerIndex;
      if (this.bannerIndex === 0) {
        this.bannerIndex = this.banner.length - 1;
      } else {
        this.bannerIndex -= 1;
      }
    },
    bannerRight() {
      this.bannerIndex2 = this.bannerIndex;
      if (this.bannerIndex === this.banner.length - 1) {
        this.bannerIndex = 0;
      } else {
        this.bannerIndex += 1;
      }
    },
    onClickDot(index) {
      this.bannerIndex2 = this.bannerIndex;
      this.bannerIndex = index;
    },
    _getList() {
      http.get('bannerList')
          .then((res) => {
            if (res.data.status === 0) {
              const dataReturn = []

              for (const i in res.data.data) {
                dataReturn.push(
                    {
                      image: res.data.data[i].b_img,
                      index: res.data.data[i].b_id,
                      url: res.data.data[i].b_url
                    }
                )
              }
              this.banner = dataReturn
            }
          })
    }
  },
};
</script>
<style scoped>
.banner {
  width: 100%;
  height: 534px;
  overflow: hidden;
  background: #f2f2f2;
  position: relative;
}

.banner .img-box {
  width: 100%;
  height: 534px;
}
.img-inner {
  height: auto;
  width: 100%;
  object-fit: cover;
}
.banner .img-box .img-item {
  width: 100%;
  height: 100%;
  line-height: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.banner .img-box .img-item.active {
  z-index: 2;
  transition: 1s;
}

.arrows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  z-index: 9;
  padding: 0 10px;
  box-sizing: border-box;
  transform: translateY(-50%);
}

.arrows div {
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}

.dots {
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 9;
}

.dots span {
  width: 10px;
  height: 10px;
  background: rgba(65, 78, 83, 0.8);
  border-radius: 50%;
  cursor: pointer;
  margin: 0 10px;
}

.dots span.active {
  background: #007bff;
}
</style>

